// @flow
/**
 * @module Epics/categoria
 * @desc Categoria
 */

import { ActionTypes } from '../utils/constants';
import { ofType, ActionsObservable } from 'redux-observable';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import querystring from 'querystring';

import { BaseApiService } from '../utils/BaseApiService';
import {
  fetchAvaluosSuccess,
  fetchAvaluosFailure,
  getAvaluoSuccess,
  getAvaluoFailure,
  sendAvaluoSuccess
} from '../actions';

export function fetchAvaluosRequest(action$: ActionsObservable) {
  return action$.pipe(
    ofType(ActionTypes.FETCH_AVALUOS_REQUEST),
    switchMap(action => {
      return BaseApiService.get(`/api/cotizador/bluebook/?${querystring.stringify(action.payload)}`).pipe(
        map(({ response: { data } }) => {
          return fetchAvaluosSuccess(data);
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(fetchAvaluosFailure(), ...actions)
        )
      );
    })
  );
}

export function getAvaluoRequest(action$: ActionsObservable) {
  return action$.pipe(
    ofType(ActionTypes.GET_AVALUO_REQUEST),
    switchMap(action => {
      return BaseApiService.post(`/api/cotizador/bluebook/?${querystring.stringify(action.payload)}`).pipe(
        map(({ response: { data } }) => {
          return getAvaluoSuccess(data);
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(getAvaluoFailure(), ...actions)
        )
      );
    })
  );
}

export function sendAvaluoRequest(action$: ActionsObservable) {
  return action$.pipe(
    ofType(ActionTypes.SEND_AVALUO_REQUEST),
    switchMap(action => {
      return BaseApiService.post(`/api/cotizador/bluebook/?${querystring.stringify(action.payload.properties)}`, action.payload.personalInfo).pipe(
        map(({ response: { data } }) => {
          return sendAvaluoSuccess();
        }),
        catchError(
          /* istanbul ignore next  */ ({ actions = [] }) =>
            of(sendAvaluoSuccess(), ...actions)
        )
      );
    })
  );
}